//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';
import constant from '~/const';
import Filters from './SettingsP2PNotificationsFilters.vue';
import problemsModal from './problemsModal.vue';
import Extra from './SettingsP2PNotificationsExtra.vue';

import tableConfig from './tableConfig';

export default {
  components: { Filters, Extra, problemsModal },

  data() {
    return {
      tableConfig,
      constant,
      dummyHints: false,
      aliasSearch: '',
      parameterSearch: '',
      warning: {
        show: false,
      },
      problemsModal: {
        show: false,
      },
      loader: false,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('settingsNotifications', [
      'page',
      'pages',
      'replacements',
      'p2pData',
      'filters',
      'sort',
    ]),

    getP2pData() {
      if (!this.aliasSearch) {
        return this.p2pData;
      }
      const searchLower = this.aliasSearch.toLowerCase();
      return this.p2pData.filter((row) => row.name.toLowerCase().includes(searchLower));
    },

    getReplacements() {
      const replacements = Object.keys(this.replacements).map((key) => ({
        parameter: key,
        role: this.replacements[key],
      }));

      if (!this.parameterSearch) {
        return replacements;
      }
      const searchLower = this.parameterSearch.toLowerCase();
      return replacements.filter((hint) => hint.parameter.toLowerCase().includes(searchLower));
    },
  },

  watch: {
    p2pData: {
      handler(newValue) {
        const objectsWithEmptyLocalisationMessages = newValue.filter((item) => {
          return Array.isArray(item.localisationMessages) && item.localisationMessages.length === 0;
        });

        const objectsWithDuplicateAliases = newValue.filter((item) => {
          if (Array.isArray(item.localisationMessages)) {
            const aliasCounts = item.localisationMessages.reduce((acc, msg) => {
              acc[msg.serviceType] = (acc[msg.serviceType] || 0) + 1;
              return acc;
            }, {});

            return Object.values(aliasCounts).some((count) => count > 1);
          }
          return false;
        });

        if (objectsWithEmptyLocalisationMessages.length !== 0) {
          this.setWarning(this.constant.notifications.WARNINGS_LIST.EMPTY_NOTIFICATIONS, objectsWithEmptyLocalisationMessages);
        }

        if (objectsWithDuplicateAliases.length !== 0) {
          this.setWarning(this.constant.notifications.WARNINGS_LIST.DUPLICATE_NOTIFICATIONS, objectsWithDuplicateAliases);
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations('settingsNotifications', {
      setNotifications: 'SET_DATA',
    }),
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('settingsNotifications', {
      loadDataAction: 'loadData',
      loadP2PMessagesAction: 'loadP2PMessages',
      loadReplacementsAction: 'loadReplacements',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
      updateNotificationTemplate: 'updateNotificationTemplate',
    }),

    async loadData(data = {}) {
      this.setGeneralLoader(true);
      await this.loadDataAction(data);
      await this.loadP2PMessagesAction(data);
      await this.loadReplacementsAction();
      this.setGeneralLoader(false);
    },

    copy(text) {
      navigator.clipboard.writeText(text);
      this.setSuccessNotification('Copied to clipboard');
    },

    searchByAlias(alias) {
      this.aliasSearch = alias;
      this.problemsModal.show = false;
    },

    setWarning(warning, content) {
      this.warning = warning;
      this.warning.show = true;
      this.warning.content = content.map((item) => item.name);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },
  },
};
